// extracted by mini-css-extract-plugin
module.exports = {"container":"SnaiPlusFrame_container__EYszQ","close":"SnaiPlusFrame_close__Nnhnt","sticky":"SnaiPlusFrame_sticky__0xEk1","isOpen":"SnaiPlusFrame_isOpen__qy6K3"};